// THE SAME STRICT SHAPES AS THE SERVER (inv_utils.labelled_shape) — a real month and day, or a number with a real
// unit. "20-6572" and "142421A" are part numbers and never match. Used to lead a row with "Date code on …" /
// "Rating on …"; the server labels the value on save whatever the screen sends.
const DATE = [
  /^(0?[1-9]|1[0-2])[/-](0?[1-9]|[12]\d|3[01])[/-](\d{2}|\d{4})$/,
  /^(19|20)\d{2}[/-](0?[1-9]|1[0-2])[/-](0?[1-9]|[12]\d|3[01])$/,
];
const RATING = [
  /^\d{1,4}(\.\d+)?\s*-?\s*(VOLTS?|VDC|VAC|AMPS?|KPA|PSI|BAR|KW|HP|RPM|GPM|WATTS?|OHMS?|CCA|AH|HZ|NM|LBS?)$/i,
  /^\d{1,3}(\.\d+)?\s*V$/i,
  /^\d{1,3}(\.\d+)?\s+(A|W)$/i,
];

export function labelledShape(value) {
  const v = String(value || "").trim();
  if (DATE.some((r) => r.test(v))) return "date_code";
  if (RATING.some((r) => r.test(v))) return "rating";
  return "";
}
